import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useSelector, useDispatch } from "react-redux";
import { getKhanAcademyVideo } from "../../../../../../redux/_actions/khanAcademyCoursesAction";
import { useHistory } from "react-router";
import VideoModal from "../../../../partails/videoModal";
import Loader from "../../../../../loader";
import "./index.scss";
const KhanVideoModal = (props) => {
  const dispatch = useDispatch();
  const videoDetail = useSelector(
    (state) => state.khanAcademyCourse.khanAcademyVideo
  );
  const history = useHistory();
  const topictitle = props?.match.params.topic;
  const back = () => {
    history.goBack();
    // } else {
    //   history.push(`/khanacademy/${coursetopic}/${coursename}/${courseunit}`);
    // }
  };

  useEffect(() => {
    dispatch(getKhanAcademyVideo(topictitle));
  }, [topictitle]);
  return videoDetail?.data ? (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{videoDetail?.data["meta_title "]}</title>
        <meta name="description" content={videoDetail?.data?.meta_description} />
      </Helmet>
      <VideoModal
        toggle={back}
        video={videoDetail?.data?.video_id}
        channel="Khan Academy"
        title={videoDetail?.data?.video_name}
      />
    </>
  ) : (
    <Loader />
  );
};
export default KhanVideoModal;
